export interface Category {
  slug: string;
  name: string;
  shortName: string;
  description: string;
  intro: string;
  image: string;
  imageAlt: string;
  accent: string;
}

export const categories: Category[] = [
  {
    slug: "baoliao",
    name: "重磅爆料",
    shortName: "爆料",
    description: "第一时间归档的圈内重磅爆料，原帖、截图与当事人回应一网打尽。",
    intro:
      "这里收录近期讨论度最高的重磅爆料。每一条都尽量把爆料原帖、关键截图、当事人回应和时间线整理在一起，方便你从头到尾看明白一件事的来龙去脉，而不是只看到被截出来的一句话。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20backdrop%20with%20dramatic%20crimson%20and%20amber%20spotlights%2C%20blurred%20microphones%20on%20a%20press%20table%2C%20no%20people%2C%20cinematic%20depth%20of%20field%2C%20grainy%20film%20texture%2C%20moody%20high%20contrast%20newsroom%20aesthetic&width=900&height=600&seq=cat-baoliao&orientation=landscape",
    imageAlt: "重磅爆料分类配图，抽象新闻发布现场灯光氛围",
    accent: "primary",
  },
  {
    slug: "jingtian",
    name: "惊天大瓜",
    shortName: "惊天",
    description: "震动全网的惊天大瓜，来龙去脉与关键节点完整还原。",
    intro:
      "被称作惊天大瓜的事件，往往牵出一串连锁反应。我们按时间顺序把每一个关键节点标出来，配上当时的原始材料和后续回应，帮你判断哪些是实锤、哪些只是网友的脑补。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20explosive%20burst%20of%20light%20through%20dark%20smoke%2C%20warm%20orange%20embers%20against%20deep%20charcoal%20background%2C%20editorial%20news%20graphic%20style%2C%20no%20people%2C%20cinematic%20contrast%2C%20fine%20grain%20texture&width=900&height=600&seq=cat-jingtian&orientation=landscape",
    imageAlt: "惊天大瓜分类配图，抽象爆炸光效氛围",
    accent: "primary",
  },
  {
    slug: "mengliao",
    name: "猛料曝光",
    shortName: "猛料",
    description: "被扒出的猛料与曝光内容，证据截图逐条对照。",
    intro:
      "猛料曝光区更看重证据。我们把爆出来的聊天记录、后台数据、对比图逐条摊开，标清来源与时间，让你自己判断可信度，而不是被标题带着走。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20stack%20of%20redacted%20documents%20and%20photographs%20scattered%20on%20a%20dark%20desk%20under%20a%20single%20amber%20desk%20lamp%2C%20no%20people%2C%20investigative%20editorial%20mood%2C%20shallow%20depth%20of%20field%2C%20warm%20shadow%20tones&width=900&height=600&seq=cat-mengliao&orientation=landscape",
    imageAlt: "猛料曝光分类配图，抽象桌面档案与灯光",
    accent: "accent",
  },
  {
    slug: "niandu",
    name: "年度大瓜",
    shortName: "年度",
    description: "一年一度的大瓜盘点与年度名场面回顾。",
    intro:
      "每到年末，我们把这一年里真正刷屏过的大瓜按热度排一遍：哪个反转最多、哪个后续最离谱、哪个当事人回应最出圈，一次看完一整年的名场面。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20stack%20of%20glossy%20magazine%20covers%20arranged%20in%20a%20grid%20on%20a%20warm%20champagne%20background%2C%20no%20people%2C%20editorial%20year%20in%20review%20aesthetic%2C%20soft%20golden%20studio%20lighting%2C%20clean%20geometry&width=900&height=600&seq=cat-niandu&orientation=landscape",
    imageAlt: "年度大瓜分类配图，抽象杂志封面排列",
    accent: "accent",
  },
  {
    slug: "chaoji",
    name: "超级大瓜",
    shortName: "超级",
    description: "跨平台连环发酵的超级大瓜，后续进展持续跟进。",
    intro:
      "超级大瓜的特点就是没完没了：昨天还在一个平台吵，今天已经蔓延到全平台。这里专门跟进那些跨平台连环发酵的事件，把每一轮新进展按顺序补上。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20interconnected%20glowing%20threads%20spreading%20across%20a%20dark%20map%20surface%20like%20viral%20ripples%2C%20crimson%20and%20amber%20glow%2C%20no%20people%2C%20data%20visualization%20editorial%20style%2C%20cinematic%20depth&width=900&height=600&seq=cat-chaoji&orientation=landscape",
    imageAlt: "超级大瓜分类配图，抽象扩散光纹",
    accent: "secondary",
  },
];

export const getCategory = (slug: string): Category | undefined =>
  categories.find((item) => item.slug === slug);